import encryptServer from '../request/encryptRequest';

// 生成子客登录链接
export const createUrl = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSign/createConsoleLoginUrl', params);

// 批量生成子客登录链接
export const batchCreateUrl = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSign/batchCreateConsoleLoginUrl', params);

// 删除子客用户
export const deleteUser = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignUser/delete', params);

// 查询电子签
export const getElectronicSignDetail = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSign/detail', params);

// 开通电子签
export const openElectronicSign = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSign/open', params);

// 批量添加子客用户
export const batchAddUser = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignUser/batchAdd', params);

// 查询子客用户列表
export const getElectronicSignList = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignUser/pageList', params);

// 腾讯电子签回调
export const tencentElectronicSignCallback = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/tencent/electronicSign/callback', params);

// 上传文件
export const uploadFiles = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/tencent/electronicSign/uploadFiles', params);

// 查询合同列表
export const getContractList = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignContract/pageList', params);

// 拉取实验室合同证书
export const getContractQuality = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignContract/pullCnasContractQuality', params, { timeout: 1000 * 60 * 10 });

// 发起合同签署流程
export const initiateFlow = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignContract/initiateFlow', params, { timeout: 1000 * 15, stopDefaultLoading: true });

// 批量上传合同文件
export const batchUploadFiles = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignContract/batchUploadFile', params, { timeout: 1000 * 60 * 2, stopDefaultLoading: true });

// 查询合同文件上传进度
export const getUploadProgress = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignContract/getUploadProgress', params, { stopDefaultLoading: true });

// 获取合同签署流程链接
export const getCreateContractFlowUrl = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/tencent/electronicSign/getCreateContractFlowUrl', params);

// 重新同步，把未实名的员工全部推到腾讯电子签平台
export const electronicSignUserReSync = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignUser/reSync', params);

// 通过数据类型和租户id查询最新记录
export const getLatestRecordByDataTypeAndTenantId = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/dataSyncRecord/getLatestRecordByDataTypeAndTenantId', params);

// 重新上传合同文件
export const reUploadContractFile = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/electronicSignContract/reUploadFile', params);
